// AppsTabTitle.js — the "Apps" tab label. One dot per app IN THE TRAY that is
// not linked to the open patient (a patient to pull in, a mismatch to confirm,
// or no context yet), each in that app's own colour — the same dots the tiles
// wear. A pinned app wears its dot on its own tab instead (WorkspaceTabs), so
// the dot always points where the app is. `only` limits it to those app ids.
import useVendorStore from '../../utils/vendorApps/useVendorStore';
import WorkspaceIcon from '../Workspace/WorkspaceIcon';

export default function AppsTabTitle({ iconMargin = '8px', compact = false, only = null }) {
  const store = useVendorStore();
  const apps = store.appsNeedingAttention().filter((a) => !only || only.includes(a.id));
  const who = store.patient?.name || 'this patient';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      <WorkspaceIcon id="apps" size={17} style={{ marginRight: compact ? 0 : iconMargin }} />
      {!compact && 'Apps'}
      {apps.length > 0 && (
        <span style={{ display: 'inline-flex', gap: 3, marginLeft: 6, verticalAlign: 'middle' }} aria-label={`${apps.map((a) => a.name).join(', ')} not linked`}>
          {apps.slice(0, 4).map((a) => (
            <span key={a.id} title={`${a.name} isn't linked to ${who} yet. Open the Apps tab to link it.`} style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: a.color || '#5e72e4' }} />
          ))}
        </span>
      )}
    </span>
  );
}
